import { defineStore } from "pinia";
import { isNetworkUnavailable } from "@/composables/network/offlineMode";
import { ReportTemplateClient } from "@/api";
import { REPORT_TYPES } from "@/db/enums/reportTypes.js";

export const useReportTemplatesStore = defineStore("reportTemplates", {
  state: () => ({
    reportTemplateList: [],
    reportTemplateIsLoading: false,
    reportTemplateForReportList: [],
  }),
  actions: {
    async fetchReportTemplates(serviceId) {
      if (isNetworkUnavailable()) return;

      this.reportTemplateIsLoading = true;

      const response = await ReportTemplateClient.list({
        service_id: serviceId,
      });

      // on garde les uuid de template type qui correspondent a des vrai rapport,
      // utiliser dans la page rapport pour ne pas afficher les borderaux d'échantillon et les bons de commande eurofins
      this.reportTemplateForReportList = response.filter(({ code }) =>
        Object.values(REPORT_TYPES).includes(code)
      );
      this.reportTemplateList = response;
      this.reportTemplateIsLoading = false;
    },
  },
});
